import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-multi-date-picker';
import PropTypes from 'prop-types';
import { Button } from 'antd';

/**
 * این کامپوننت برای نمایش اینپوت تاریخ است
 */
export default function InputDate({
  label,
  name,
  defaultValue,
  handelValue,
  disabled,
}) {
  const [selectedDay, setSelectedDay] = useState();

  const handeloncheng = (event) => {
    setSelectedDay(event);
    const createmiladi = jalali_to_gregorian(
      event?.year,
      event?.month.number,
      event?.day
    );
    const data = `${createmiladi[0]}-${
      createmiladi[1] < 10 ? '0' + createmiladi[1] : createmiladi[1]
    }-${createmiladi[2] < 10 ? '0' + createmiladi[2] : createmiladi[2]}`;
    if (event?.isValid) {
      handelValue(name, data);
    } else {
      handelValue(name, null);
    }
  };

  const clear = () => {
    setSelectedDay(null);
    handelValue(name, null);
  };

  useEffect(() => {
    if (defaultValue) {
      const split = defaultValue.split('-');

      const defaultdate = gregorian_to_jalali(
        parseInt(split[0]),
        parseInt(split[1]),
        parseInt(split[2])
      );

      setSelectedDay(
        `${parseInt(defaultdate[0])}-${parseInt(defaultdate[1])}-${parseInt(
          defaultdate[2]
        )}`
      );
    } else {
      setSelectedDay(null);
    }
    return () => {};
  }, [defaultValue]);

  const clearButtonStyle = {
    color: '#919191',
    height: '3rem',
    marginTop: '2px',
    fontSize: '2rem',
    padding: '0 1rem 0 0',
  };

  // const renderCustomInput = ({ ref }) => (
  //   <input
  //     readOnly
  //     dir='ltr'
  //     ref={ref}
  //     placeholder={label}
  //     disabled={disabled}
  //     value={
  //       selectedDay.year
  //         ? ` ${selectedDay.year} / ${selectedDay.month} /${selectedDay.day}`
  //         : ''
  //     }
  //     style={{ width: '100%', height: '50px', zIndex: '999' }}
  //   />
  // );

  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <br />
      <div className='d-flex'>
        <DatePicker
          className='purple'
          format='YYYY/MM/DD'
          calendar='persian'
          locale='fa'
          disabled={disabled}
          style={{
            direction: 'rtl',
            fontFamily: 'ShabnamFD',
            width: '100%',
            height: '50px',
            zIndex: '999',
            textAlign: 'center',
          }}
          calendarPosition='bottom-center'
          animation
          Type='input-icon'
          onChange={handeloncheng}
          value={selectedDay}
          editable={true}
        />
        <Button type='text' onClick={() => clear()} style={clearButtonStyle}>
          ×
        </Button>
      </div>
    </Form.Group>
  );
}

InputDate.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
};

function jalali_to_gregorian(jy, jm, jd) {
  var sal_a, gy, gm, gd, days;
  jy += 1595;
  days =
    -355668 +
    365 * jy +
    ~~(jy / 33) * 8 +
    ~~(((jy % 33) + 3) / 4) +
    jd +
    (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
  gy = 400 * ~~(days / 146097);
  days %= 146097;
  if (days > 36524) {
    gy += 100 * ~~(--days / 36524);
    days %= 36524;
    if (days >= 365) days++;
  }
  gy += 4 * ~~(days / 1461);
  days %= 1461;
  if (days > 365) {
    gy += ~~((days - 1) / 365);
    days = (days - 1) % 365;
  }
  gd = days + 1;
  sal_a = [
    0,
    31,
    (gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
  return [gy, gm, gd];
}

function gregorian_to_jalali(gy, gm, gd) {
  var g_d_m, jy, jm, jd, gy2, days;
  g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  gy2 = gm > 2 ? gy + 1 : gy;
  days =
    355666 +
    365 * gy +
    ~~((gy2 + 3) / 4) -
    ~~((gy2 + 99) / 100) +
    ~~((gy2 + 399) / 400) +
    gd +
    g_d_m[gm - 1];
  jy = -1595 + 33 * ~~(days / 12053);
  days %= 12053;
  jy += 4 * ~~(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += ~~((days - 1) / 365);
    days = (days - 1) % 365;
  }
  if (days < 186) {
    jm = 1 + ~~(days / 31);
    jd = 1 + (days % 31);
  } else {
    jm = 7 + ~~((days - 186) / 30);
    jd = 1 + ((days - 186) % 30);
  }
  return [jy, jm, jd];
}
